module.exports = __webpack_public_path__ + "img/accountTxt.1c67989a.png";